export const PRIMARY_BLUE_SHIVVERS = "#005893";
export const ORANGE_SHIVVERS = "#E38A3D";